import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-71f7911b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "l-wrapper" }
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "お知らせ", -1))
const _hoisted_4 = { class: "p-news" }
const _hoisted_5 = { class: "u-mn-hidden" }
const _hoisted_6 = { class: "p-news_date" }
const _hoisted_7 = { class: "p-news_heading" }
const _hoisted_8 = ["innerHTML"]

import Loading from '@/components/Loading.vue';


import { onBeforeMount } from 'vue';
import { useStore } from 'vuex';
import { RouterLink, useRoute, useRouter } from 'vue-router';
import { MypageNews } from '@/types';

import { ref } from 'vue';
import { mypageUtils } from '@/utils/mypage';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsView',
  setup(__props) {

const store = useStore();
const route = useRoute();

const mypageNews = ref<MypageNews>({
  newsId: '',
  newsTitle: '',
  newsText: '',
  dispdateFrom: ''
});

const isLoading = ref(false);
const router = useRouter();
const handleBack = () => {
  let previousRoute = store.getters['router/previousRoute'];
  mypageUtils.handleBack(router, previousRoute);
};

// HTMLエンティティをデコードする関数
const decodeHtmlEntities = (text: string) => {
  const parser = new DOMParser();
  const decodedString = parser.parseFromString(text, 'text/html').body.textContent;
  return decodedString || '';
};

onBeforeMount(async () => {
  isLoading.value = true; // ローディング開始

  // URLパラメータからnewsIdを取得
  const newsId = route.params.newsId as string;

  if (newsId) {
    await store.dispatch('news/select', { newsId: newsId });
    const fetchedNews = store.getters['news/mypageNewsInfo'];

    if (fetchedNews) {
      // newsTextのHTMLエンティティをデコードして代入
      mypageNews.value = {
        ...fetchedNews,
        newsText: decodeHtmlEntities(fetchedNews.newsText),
      } as MypageNews;
    }
  }

  isLoading.value = false; // ローディング終了
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", { class: "c-head-mn u-lg-hidden" }, [
          _createElementVNode("button", {
            onClick: handleBack,
            "aria-label": "戻る"
          }),
          _hoisted_3
        ]),
        _createElementVNode("main", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(RouterLink), {
              class: "p-news_home",
              to: "/"
            }, {
              default: _withCtx(() => [
                _createTextVNode("ホーム")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("p", _hoisted_6, _toDisplayString(mypageNews.value.dispdateFrom), 1),
          _createElementVNode("h1", _hoisted_7, _toDisplayString(mypageNews.value.newsTitle), 1),
          _createElementVNode("div", {
            class: "p-news_text",
            innerHTML: mypageNews.value.newsText
          }, null, 8, _hoisted_8)
        ])
      ])
    ]),
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"])
  ], 64))
}
}

})